import angular from "angular";
import $ from 'jquery';

angular
    .module('ui-sentinel.shipments.shipmentNew')
    .controller('ShipmentNewController', ShipmentNewController);

ShipmentNewController.$inject = ['$rootScope', '$timeout', '$scope', '$state', 'AlarmContactsService', 'DateFormatService', 'DevicesService', 'SentinelUiSession', 'FeedbackService', 'LatestDeviceTrackingReportsService', 'TemplateEditorService', 'ShipmentEditorService', 'PolygonGeofencesService', 'RadialGeofencesService', 'ShipmentTemplatesDataLoaderService', 'DatetimeValidatorService', 'SentryAdminApiService', 'SentinelAdminApiService', 'SentinelAccountApiService', 'SentryAccountApiService', 'ShipmentTemplatesService', 'HideShipmentStopTimes', 'ApiErrorService'];

function ShipmentNewController($rootScope, $timeout, $scope, $state, AlarmContactsService, DateFormatService, DevicesService, SentinelUiSession, FeedbackService, LatestDeviceTrackingReportsService, TemplateEditorService, ShipmentEditorService, PolygonGeofencesService, RadialGeofencesService, ShipmentTemplatesDataLoaderService, DatetimeValidatorService, SentryAdminApiService, SentinelAdminApiService, SentinelAccountApiService, SentryAccountApiService, ShipmentTemplatesService, HideShipmentStopTimes, ApiErrorService) {

    console.log(`SentinelUiSession:`, SentinelUiSession);
    const vm = {
        hideShipmentStopTimes: HideShipmentStopTimes,
        feedback: FeedbackService,
        availableDevices: [],
        availableSentinels: [],
        availableGeofences: [],
        lastReports: [],
        filterSentrysTimeout: null,
        filterSentinelsTimeout: null,
        deviceSearchText: null,
        endGeofenceSearchText: null,
        endGeofence2SearchText: null,
        beginGeofenceSearchText: null,
        sentinelSearchText: null,
        sentinelFilter: sentinelFilter,
        endGeofenceFilter: endGeofenceFilter,
        endGeofence2Filter: endGeofence2Filter,
        beginGeofenceFilter: beginGeofenceFilter,
        changeSentryFilter: changeSentryFilter,
        templateSearchText: null,
        templateCount: 0,
        isTemplateSearchMode: false,
        templateEditor: TemplateEditorService,
        dateFormatService: DateFormatService,
        templateFilter: templateFilter,
        selectedAlarmFilter: selectedAlarmFilter,
        availableTemplates: [],
        listLimit: 5,
        itemsPerPage: 5,
        availableAlarms: [],
        shipmentEditor: ShipmentEditorService,
        isOrs: $rootScope.isOrs,
        isOrsTopLevel: undefined,
        isFocused: undefined,
        orsSubAccountHide: () => {
            return vm.isOrsTopLevel && vm.isFocused;
        },
        isAiTracking: SentinelUiSession.focus.isFocused ? SentinelUiSession.focus.isAiTracking : SentinelUiSession.user.isAiTracking,
        trackingDeviceLabel: $rootScope.isOrs ? 'GPS Tracker' : 'Tracking device',
        searchSentryLabel: $rootScope.isOrs ? 'Search GPS Tracker' : 'Search Sentry',
        deviceLabel: $rootScope.isOrs ? 'GPS Tracker' : 'Device',
        nameLabel: $rootScope.isOrs ? 'LifePort S/N' : 'Name',
        lastReportedLabel: $rootScope.isOrs ? 'Last Reported Time' : 'Last Reported',
        lastBatteryLabel: $rootScope.isOrs ? 'Last GPS Battery %' : 'Last Battery %',
        sentriesInitialized: false,
        sentinelsInitialized: false,
        isValidating: false,
        currentPage: 'start',
        filter: 'all',
        page: 1,
        saveAsTemplatePage: {
            isShowing: false,
            includeBeginTrackingStrategy: false,
            includeEndTrackingStrategy: false,
            close: closeSaveAsTemplate,
            save: createTemplate
        },
        startPage: {
            isShowingTemplates: false,
            selectedTemplateName: null,
            selectedTemplate: null,
            reverseGeofences: false,
            deviceNameText: null,
            endGeofenceNameText: null,
            endGeofence2NameText: null,
            beginGeofenceNameText: null,
            isValid: false
        },
        stopsPage: {
            isPristine: true,
            isValid: false
        },
        alarmsPage: {
            alarms: [],
            isVisited: false,
            isValid: isAlarmsValid
        },
        finishPage: {
            isValid: false
        },
        sentry_scan_options: {
            minLength: 15,
            avgTimeByChar: 10,
            onComplete: function () {
                console.log("sentry_scan_options", vm.deviceSearchText);
                vm.changeSentryFilter(vm.deviceSearchText, true);
            }
        },
        sentinel_scan_options: {
            minLength: 12,
            avgTimeByChar: 10,
            onComplete: function () {
                console.log("sentinel", vm.sentinelSearchText);
                vm.sentinelFilter(vm.sentinelSearchText, true);
            }
        },
        contacts: [],
        actions: {
            close: close,
            create: create,
            next: next,
            back: back,
            validateSubscribers: validateSubscribers,
            addStop: addStop,
            removeStop: removeStop,
            selectDevice: selectDevice,
            selectSentinel: selectSentinel,
            removeSentinel: removeSentinel,
            clearDevice: clearDevice,
            clearSentinel: clearSentinel,
            clearEndGeofence: clearEndGeofence,
            clearEndGeofence2: clearEndGeofence2,
            clearBeginGeofence: clearBeginGeofence,
            selectEndGeofence: selectEndGeofence,
            selectEndGeofence2: selectEndGeofence2,
            selectBeginGeofence: selectBeginGeofence,
            formatSentinelValue: formatSentinelValue,
            showTemplates: showTemplates,
            searchTemplates: searchTemplates,
            hideTemplates: hideTemplates,
            selectTemplate: selectTemplate,
            updateTemplate: updateTemplate,
            beginSaveAsTemplate: beginSaveAsTemplate,
            applyTemplateTrackingStrategy: applyTemplateTrackingStrategy
        }
    };
    activate();
    return vm;

    function activate() {
        vm.feedback.clear();
        $rootScope.$on('CLIENT_FOCUS_CHANGED', function (event, args) {
            if ($state.current.name === 'shipment-new') {
                vm.shipmentEditor.init();
                vm.availableTemplates = [];
                ShipmentTemplatesDataLoaderService.load();
                loadDevices();
                loadSentinels();
                resetWizard();
                $state.go('shipments.list');
            }
        });

        $rootScope.$on('SHIPMENT_STOP_REMOVED', function (event, args) {
            removeStop(args.index);
        });

        $rootScope.$on('SHIPMENT_STOP_ADDED', function (event, args) {
            console.log("SHIPMENT_STOP_ADDED", args);

            let stopAlreadyExist = false;
            if (vm.shipmentEditor.stops && vm.shipmentEditor.stops["other"] && vm.shipmentEditor.stops["other"].length > 0) {
                console.log("others", vm.shipmentEditor.stops["other"]);
                for (let i = 0; i < vm.shipmentEditor.stops["other"].length; i++) {
                    const s = vm.shipmentEditor.stops["other"][i];
                    if (s.stopId == args.stop.stopId)
                        continue;
                    console.log("stop", args.stop);
                    console.log("s", s);
                    if (args.stop.type === s.type) {
                        if (s.type === "address") {
                            if (args.stop.address.value === s.address.value) {
                                stopAlreadyExist = true;
                                break;
                            }
                        } else if (s.type === "geofence") {
                            if (args.stop.geofence.name === s.geofence.name) {
                                stopAlreadyExist = true;
                                break;
                            }
                        }
                    }
                }
            }
            console.log("stopAlreadyExist", stopAlreadyExist);
            if (stopAlreadyExist) {
                vm.shipmentEditor.removeStop(args.stop.stopId);
                vm.feedback.addError("Stop already exists");
                $(window).scrollTop(0, 0);
            }
        });

        $scope.$watch(
            function () {
                return SentinelUiSession.focus;
            },
            function (focus) {
                vm.isFocused = focus ? focus.isFocused : undefined;
            }
        );
        $scope.$watch(
            function () {
                return SentinelUiSession.user;
            },
            function (user) {
                vm.isOrsTopLevel = user ? user.isOrsTopLevel : undefined;
            }
        );

        vm.shipmentEditor.init();

        loadContacts();
        loadDevices();
        loadSentinels();
        loadGeofences();

        $scope.$watchCollection(
            function () {
                return ShipmentTemplatesDataLoaderService.templates;
            },
            function (value) {
                onTemplatesChange();
            }
        );
        $scope.$watch(
            function () {
                return ShipmentTemplatesDataLoaderService.totalTemplates;
            },
            function (value) {
                vm.templateCount = ShipmentTemplatesDataLoaderService.totalTemplates;
            }, true
        );
        $scope.$watch(
            function () {
                return ShipmentTemplatesDataLoaderService.isSearchRequired;
            },
            function (value) {
                vm.isTemplateSearchMode = ShipmentTemplatesDataLoaderService.isSearchRequired;
            }, true
        );
        $scope.$watch(
            function () {
                return vm.currentPage;
            },
            function (value) {
                if (vm.currentPage === 'alarms') {
                    vm.alarmsPage.isVisited = true;
                }
                vm.finishPage.isValid = isWizardValid();
            }, true
        );
        $scope.$watch(
            function () {
                return SentinelUiSession.focus?.trackingConfig;
            },
            function (value) {
                vm.shipmentEditor.referencePrefix = value && value.referencePrefix ? value.referencePrefix : null;
            }, true
        );
    }

    function addStop() {
        vm.shipmentEditor.addStop('address');
    }

    function formatSentinelValue(sentinel) {
        if (sentinel.friendlyName) {
            return sentinel.friendlyName + " [" + sentinel.deviceId + "]";
        }
        return sentinel.deviceId;
    }

    function addStops(shipment) {

        if (!vm.shipmentEditor.stops.other || vm.shipmentEditor.stops.other.length == 0)
            return;

        const promise = vm.shipmentEditor.saveNewStops(shipment);

        if (!promise) {
            return;
        }

        promise.$promise.then(
            function (result) {

            },
            function (error) {
                console.log("error", error);
                console.log("error.data.message", error.data?.message || error.message || 'Unknown error');
                vm.feedback.addErrorFromError(error);
            }
        );
    }

    function addAlarms(shipment) {
        console.log("shipment created", shipment);
        const sentinels = vm.shipmentEditor.sentinels;
        _.forEach(vm.alarmsPage.alarms, function (availableAlarm) {
            if (availableAlarm.isAdded) {
                const addPromise = DevicesService.addAlarm(shipment.shipmentInfo.deviceTagId, availableAlarm, shipment.shipmentInfo.shipmentId).$promise;
                addPromise.then(
                    function (result) {
                        console.log("addAlarms", result);
                        _.forEach(sentinels, function (s) {
                            const addPromise = DevicesService.addAlarmSentinel(s, availableAlarm, shipment.shipmentInfo.shipmentId).$promise;
                            addPromise.then(
                                function (result) {
                                    console.log("addAlarms", result);
                                },
                                function (error) {
                                    vm.feedback.addError('Could not add ' + availableAlarm.alarmName);
                                }
                            );
                        });

                    },
                    function (error) {
                        vm.feedback.addError('Could not add ' + availableAlarm.alarmName);
                    }
                );
            }
        });
    }

    function applyTemplateStop(templateStop, shipmentStop) {
        if (shipmentStop.address) {
            shipmentStop.address.value = null;
            shipmentStop.address.isChanging = false;
        }
        if (shipmentStop.locationSearch) {
            shipmentStop.locationSearch.value = null;
            shipmentStop.locationSearch.location = null;
            shipmentStop.locationSearch.availableLocations = [];
        }
        if (shipmentStop.geofence) {
            shipmentStop.geofence.value = null;
            shipmentStop.geofence.name = null;
            shipmentStop.geofence.isChanging = false;
        }


        if (templateStop.type === 'address') {
            shipmentStop.type = templateStop.type;
            if (templateStop.address.value) {
                shipmentStop.address.isChanging = false;
                shipmentStop.address.value = templateStop.address.value;
                shipmentStop.locationSearch.value = templateStop.address.value;

                const geoCoder = new google.maps.Geocoder();
                geoCoder.geocode({ 'address': shipmentStop.address.value }, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK && results.length === 1) {
                        shipmentStop.locationSearch.location = results[0];
                        shipmentStop.address.value = shipmentStop.locationSearch.location.formatted_address;
                        $scope.$apply();
                    }
                });
            } else {
                shipmentStop.address.isChanging = true;
            }
        }

        if (templateStop.type === 'geofence' && templateStop.geofence !== null) {
            shipmentStop.type = templateStop.type;
            if (templateStop.geofence.name) {
                shipmentStop.geofence.value = templateStop.geofence.value;
                shipmentStop.geofence.name = templateStop.geofence.name;
                shipmentStop.geofence.isChanging = false;
            } else {
                shipmentStop.geofence.isChanging = true;
            }

        }

    }

    function back() {
        switch (vm.currentPage) {
            case 'finish':
                vm.currentPage = 'alarms';
                vm.currentPage = vm.isOrs ? 'stops' : 'alarms';
                break;
            case 'alarms':
                vm.currentPage = 'stops';
                break;
            default:
                vm.currentPage = 'start';
                break;
        }
    }

    function beginSaveAsTemplate() {
        vm.saveAsTemplatePage.isShowing = true;
        vm.saveAsTemplatePage.includeBeginTrackingStrategy = false;
        vm.saveAsTemplatePage.includeEndTrackingStrategy = false;
        vm.templateEditor.clear();
        const editorBeginDateMoment = moment(vm.shipmentEditor.beginDate.value, "L");
        const editorEndDateMoment = moment(vm.shipmentEditor.endDate.value, "L");
        if (editorBeginDateMoment.isValid() && editorEndDateMoment.isValid()) {
            const duration = editorEndDateMoment.startOf('day').diff(editorBeginDateMoment.startOf('day'), 'days');
            vm.templateEditor.duration.value = duration >= vm.templateEditor.duration.min && duration <= vm.templateEditor.duration.max ? duration : null;
        }
    }

    function clearDevice() {
        vm.shipmentEditor.device.value = null;
        vm.shipmentEditor.device.isPristine = true;
        vm.startPage.deviceNameText = null;
    }

    function clearEndGeofence() {
        vm.shipmentEditor.endGeofence.value = null;
        vm.shipmentEditor.endGeofence.isPristine = true;
    }

    function clearEndGeofence2() {
        vm.shipmentEditor.endGeofence2.value = null;
        vm.shipmentEditor.endGeofence2.isPristine = true;
    }

    function clearBeginGeofence() {
        vm.shipmentEditor.beginGeofence.value = null;
        vm.shipmentEditor.beginGeofence.isPristine = true;
    }

    function clearSentinel() {
        vm.shipmentEditor.sentinels = [];
    }

    function close() {
        vm.shipmentEditor.clear();
        $state.go('shipments.list');
    }

    function closeSaveAsTemplate() {
        vm.saveAsTemplatePage.isShowing = false;
    }

    function create() {
        vm.feedback.clear();
        $rootScope.loading = true;
        vm.shipmentEditor.saveNew().then(function (result) {
            if (!result) {
                $rootScope.loading = false;
                if (!vm.shipmentEditor.isValidInfo) {
                    vm.currentPage = 'start';
                }
                return;
            }

            result.$promise.then(
                function (result) {
                    $rootScope.loading = false;
                    const referenceNumber = vm.shipmentEditor.referencePrefix ? vm.shipmentEditor.referencePrefix + vm.shipmentEditor.referenceNumber.value : vm.shipmentEditor.referenceNumber.value;
                    vm.feedback.addSavedWithSentinelPairing('Shipment ' + referenceNumber + ' has been created', result.sentinelPairing);
                    addStops(result);
                    addAlarms(result);
                    resetWizard();
                },
                function (error) {
                    $rootScope.loading = false;
                    console.log("error", error);
                    if (vm.shipmentEditor.referenceNumber.hasError()) {
                        console.log("hasError", vm.shipmentEditor.referenceNumber.hasError());
                        vm.currentPage = 'start';
                        return;
                    }

                    if (error.data.modelState) {
                        console.log("error.data.modelState", error.data.modelState);
                        const stateModelError = error.data.modelState[Object.keys(error.data.modelState)][0];
                        vm.feedback.addError(stateModelError);
                        vm.currentPage = 'start';
                        return;
                    }
                    const errorMessage = ApiErrorService.getMessage(error, error.message || 'Unknown error');
                    console.log("error.data.message", errorMessage);
                    console.log(vm.feedback);
                    if (errorMessage.toLowerCase().indexOf('reference number') >= 0 && errorMessage.toLowerCase().indexOf('already in use') >= 0) {
                        vm.shipmentEditor.referenceNumber.isPristine = false;
                        vm.shipmentEditor.referenceNumber.errors.isDuplicate = true;
                    } else {
                        vm.feedback.addErrorFromError(error);
                    }
                    vm.currentPage = 'start';
                }
            );
        });
    }

    function createTemplate() {
        vm.templateEditor.name.validate();
        vm.templateEditor.duration.validate();

        if (vm.templateEditor.name.hasError() || vm.templateEditor.duration.hasError()) {
            return;
        }

        vm.templateEditor.subscribers = vm.shipmentEditor.subscribers;
        vm.templateEditor.shipmentEmails.value = vm.shipmentEditor.shipmentEmails.value;
        vm.templateEditor.device.value = vm.shipmentEditor.device.value;
        vm.templateEditor.sentinels = vm.shipmentEditor.sentinels;
        vm.templateEditor.setTrackingStrategyFromShipmentEditor(vm.shipmentEditor, {
            includeBegin: vm.saveAsTemplatePage.includeBeginTrackingStrategy,
            includeEnd: vm.saveAsTemplatePage.includeEndTrackingStrategy
        });

        console.log("vm.shipmentEditor.stops.other", vm.shipmentEditor.stops.other);

        _.forEach(vm.shipmentEditor.stops.other, function (stop) {
            stop.validate();
            if (!stop.hasError()) {
                vm.templateEditor.stops.other.push(stop);
            }
        });

        vm.templateEditor.validateStops();
        if (vm.templateEditor.stops.hasError()) {
            return;
        }

        const templateName = vm.templateEditor.name.value;
        const promise = vm.templateEditor.save();
        if (promise === null) {
            reportTrackingStrategyError();
            return;
        }
        $rootScope.loading = true;
        promise.then(
            function (result) {
                $rootScope.loading = false;
                vm.feedback.addSuccess(templateName + ' has been created');
                const promise2 = vm.templateEditor.createStops(result);
                if (promise2 !== null) {
                    promise2.then(
                        function (r) {
                            vm.templateEditor.edit(result, vm.availableGeofences);
                            vm.startPage.selectedTemplate = result;
                            vm.startPage.selectedTemplateName = templateName;
                            closeSaveAsTemplate();
                        },
                        function (error) {
                            vm.feedback.addErrorFromError(error);
                        }
                    );
                } else {
                    vm.templateEditor.edit(result, vm.availableGeofences);
                    vm.startPage.selectedTemplate = result;
                    vm.startPage.selectedTemplateName = templateName;
                    closeSaveAsTemplate();
                }
            },
            function (error) {
                $rootScope.loading = false;
                vm.feedback.addErrorFromError(error);
            }
        );
    }

    function changeSentryFilter(filter, forScanner) {
        if (!filter) {
            filter = "";
        }

        filter = filter.replace(/\//g, '');

        console.log("changeSentryFilter", filter);

        $rootScope.loading = true;
        const promise = SentryAccountApiService.getDevicesForASML(SentinelUiSession.focus, filter).$promise;

        promise.then(
            function (result) {
                console.log("Sentries", result);
                vm.availableDevices = result;
                if (result && result.length === 1 && forScanner && forScanner === true) {
                    vm.actions.selectDevice(result[0]);
                    document.getElementById("addSentinelInput").focus();
                } else if (result && result.length === 0 && forScanner && forScanner === true) {
                    vm.deviceSearchText = "";
                }
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
            vm.sentriesInitialized = true;
        });

    }

    function endGeofenceFilter(geofence) {
        if (vm.endGeofenceSearchText === null || vm.endGeofenceSearchText === '') {
            return true;
        }

        const text = vm.endGeofenceSearchText.toLowerCase();
        return geofence.name.toLowerCase().indexOf(text) >= 0;
    }

    function endGeofence2Filter(geofence) {
        if (vm.endGeofence2SearchText === null || vm.endGeofence2SearchText === '') {
            return true;
        }

        const text = vm.endGeofence2SearchText.toLowerCase();
        return geofence.name.toLowerCase().indexOf(text) >= 0;
    }

    function beginGeofenceFilter(geofence) {
        if (vm.beginGeofenceSearchText === null || vm.beginGeofenceSearchText === '') {
            return true;
        }

        const text = vm.beginGeofenceSearchText.toLowerCase();
        return geofence.name.toLowerCase().indexOf(text) >= 0;
    }

    function sentinelFilter(filter, forScanner) {
        if (!filter) {
            filter = "";
        }

        filter = filter.replace(/\//g, '');

        console.log("sentinelFilter", filter);

        $rootScope.loading = true;
        const promise = SentinelAccountApiService.getSentinelsForASML(SentinelUiSession.focus, filter).$promise;

        promise.then(
            function (result) {
                console.log("Sentinels", result);
                vm.availableSentinels = result;
                if (result && result.length === 1 && forScanner && forScanner === true) {
                    vm.actions.selectSentinel(result[0]);
                    vm.sentinelSearchText = "";
                } else if (result && result.length === 0 && forScanner && forScanner === true) {
                    vm.sentinelSearchText = "";
                }
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
            vm.sentinelsInitialized = true;
        });

    }

    function formattedStops(template) {
        const stops = [];

        _.forEach(template.stops, function (templateStop) {
            if (templateStop.stopType.toLowerCase() === 'stop') {
                stops.push(toFormattedStop(templateStop));
            }
        });

        return stops;
    }

    function hideTemplates() {
        vm.startPage.isShowingTemplates = false;
        vm.templateSearchText = null;
        vm.availableTemplates = [];
    }

    function isAlarmsValid() {
        return vm.alarmsPage.isVisited;
    }

    function isWizardValid() {
        return vm.shipmentEditor.isValid && isAlarmsValid();
    }

    function loadContacts() {
        var promise = (SentinelUiSession.user.accountId == SentinelUiSession.focus.id) ?
            AlarmContactsService.getContacts().$promise :
            AlarmContactsService.getContactsForClient(SentinelUiSession.focus).$promise;

        $rootScope.loading = true;
        promise.then(
            function (result) {
                vm.contacts = result;
            },
            function (error) {
                console.log(error);
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function loadDevices() {
        vm.availableDevices = [];
        vm.startPage.deviceNameText = null;
        $rootScope.loading = true;

        const promise = SentryAccountApiService.getDevicesForASML(SentinelUiSession.focus, "").$promise;

        $rootScope.loading = true;
        promise.then(
            function (result) {
                console.log("Sentries", result);
                vm.availableDevices = result;
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function loadSentinels() {
        vm.availableSentinels = [];
        const promise = SentinelAccountApiService.getSentinelsForASML(SentinelUiSession.focus, "").$promise;
        promise.then(
            function (result) {
                console.log("Sentinels", result);
                vm.availableSentinels = result;
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        );
    }

    function loadGeofences() {
        vm.availableGeofences = [];
        const polygonPromise = PolygonGeofencesService.getGeofences(SentinelUiSession.focus).$promise;
        polygonPromise.then(
            function (result) {
                vm.availableGeofences = vm.availableGeofences.concat(result);
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        );
        const radialPromise = RadialGeofencesService.getGeofences(SentinelUiSession.focus).$promise;
        radialPromise.then(
            function (result) {
                vm.availableGeofences = vm.availableGeofences.concat(result);
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        );
    }

    function next() {
        if (vm.isValidating) {
            return;
        }

        switch (vm.currentPage) {
            case 'start':
                vm.isValidating = true;
                $rootScope.loading = true;
                vm.shipmentEditor.referenceNumber.validate().then(function () {
                    validateStart();
                    if (vm.startPage.isValid) {
                        vm.currentPage = 'stops';
                        console.log("Alarms....");
                    }
                }).catch(function (error) {
                    vm.feedback.addErrorFromError(error);
                }).finally(function () {
                    vm.isValidating = false;
                    $rootScope.loading = false;
                });
                break;
            case 'stops':
                validateStops();
                vm.stopsPage.isValid = !vm.shipmentEditor.stops.hasError();
                if (vm.stopsPage.isValid) {
                    vm.currentPage = vm.isOrs ? 'finish' : 'alarms';
                }
                break;
            case 'alarms':
                vm.currentPage = 'finish';
                break;
            default:
                vm.currentPage = 'start';
                break;
        }
    }

    function onTemplatesChange() {
        const templates = ShipmentTemplatesDataLoaderService.templates;
        _.forEach(templates, function (template) {
            template.formattedStops = formattedStops(template);
        });
        vm.availableTemplates = templates;
    }

    function removeStop(stopId) {
        vm.shipmentEditor.removeStop(stopId);
    }

    function resetWizard() {
        vm.shipmentEditor.reset();

        vm.startPage = {
            isShowingTemplates: false,
            selectedTemplateName: null,
            selectedTemplate: null,
            reverseGeofences: false,
            deviceNameText: null,
            isValid: false
        };
        vm.stopsPage = {
            isPristine: true,
            isValid: false
        };
        vm.alarmsPage = {
            alarms: [],
            isVisited: false,
            isValid: isAlarmsValid
        };
        vm.finishPage = {
            isValid: false
        };
        vm.currentPage = 'start';
        $scope.$broadcast('resetWizard');
    }

    function searchTemplates() {
        if (!vm.startPage.isShowingTemplates) {
            return;
        }
        vm.availableTemplates = [];

        if (!ShipmentTemplatesDataLoaderService.isSearchRequired) {
            ShipmentTemplatesDataLoaderService.load();
            return;
        }

        if (vm.templateSearchText && vm.templateSearchText.length > 1) {
            ShipmentTemplatesDataLoaderService.search(vm.templateSearchText, 10);
            return;
        }

        ShipmentTemplatesDataLoaderService.clear();
    }

    function selectedAlarmFilter(alarm) {
        return alarm.isAdded;
    }

    function selectDevice(device) {
        vm.shipmentEditor.device.isPristine = false;
        vm.shipmentEditor.device.value = device;
        vm.startPage.deviceNameText = device.imei;

        if (device.friendlyName) {
            const name = device.nickName ? device.friendlyName + " / " + device.nickName : device.friendlyName;
            vm.startPage.deviceNameText = name + " [" + device.imei + "]";
        }
        vm.shipmentEditor.sentinelValidation.errors.tooMany = false;
    }

    function selectEndGeofence(g) {
        vm.shipmentEditor.endGeofence.isPristine = false;
        vm.shipmentEditor.endGeofence.value = g;
        vm.startPage.endGeofenceNameText = g.name + ", " + g.address + "(" + g.type + ")";
    }

    function selectEndGeofence2(g) {
        vm.shipmentEditor.endGeofence2.isPristine = false;
        vm.shipmentEditor.endGeofence2.value = g;
        vm.startPage.endGeofence2NameText = g.name + ", " + g.address + "(" + g.type + ")";
        vm.shipmentEditor.endGeofence2.errors.isBlank = false;
        vm.shipmentEditor.endGeofence2.errors.thisOrLight = false;
        vm.shipmentEditor.arrivalLightLevel.errors.thisOrGeofence = false;
    }

    function selectBeginGeofence(g) {
        vm.shipmentEditor.beginGeofence.isPristine = false;
        vm.shipmentEditor.beginGeofence.value = g;
        vm.startPage.beginGeofenceNameText = g.name + ", " + g.address + "(" + g.type + ")";
    }

    function selectSentinel(sentinel) {
        if (vm.shipmentEditor.device.value === null && vm.shipmentEditor.sentinels.length >= 1) {
            return;
        }
        const exists = _.find(vm.shipmentEditor.sentinels, function (s) {
            return s.deviceId === sentinel.deviceId;
        });
        if (!exists)
            vm.shipmentEditor.sentinels.push(sentinel);
    }

    function removeSentinel(sentinel, $index) {
        vm.shipmentEditor.sentinels.splice($index, 1);
        vm.shipmentEditor.sentinelValidation.errors.tooMany =
            vm.shipmentEditor.device.value === null && vm.shipmentEditor.sentinels.length > 1;
    }

    function selectTemplate(template) {
        vm.startPage.isShowingTemplates = false;
        $rootScope.loading = true;
        const promise2 = ShipmentTemplatesService.getStops(SentinelUiSession.focus, template.id).$promise;
        promise2.then(
            function (stops) {
                template.stops = stops;
                vm.startPage.selectedTemplate = template;
                vm.startPage.selectedTemplateName = template.name;
                vm.templateEditor.clear();
                vm.templateEditor.edit(template, vm.availableGeofences);
                vm.startPage.reverseGeofences = false;
                applyTemplateTrackingStrategy();
                // keep the current end date when the template has no duration to apply; the end date is
                // sent for every end tracking strategy, but is only editable for the date/time strategy
                const beginDateMoment = moment(vm.shipmentEditor.beginDate.value, "L");
                if (beginDateMoment.isValid() && vm.templateEditor.duration.value >= vm.templateEditor.duration.min) {
                    const endDateMoment = beginDateMoment.add(vm.templateEditor.duration.value, 'days').endOf('day').startOf('minute');
                    if (endDateMoment.isValid()) {
                        vm.shipmentEditor.endDate.value = endDateMoment.toDate();
                    }
                }
                vm.shipmentEditor.subscribers = vm.templateEditor.subscribers;
                vm.shipmentEditor.shipmentEmails.value = template.shipmentEmails !== null ? vm.shipmentEditor.joinEmails(template.shipmentEmails) : null;
                if (template.deviceTagId) {
                    selectDevice({ imei: template.deviceTagId });
                } else {
                    vm.shipmentEditor.device.value = null;
                    vm.shipmentEditor.device.isPristine = true;
                    vm.startPage.deviceNameText = null;
                }
                _.forEach(template.sentinels, function (s) {
                    vm.shipmentEditor.sentinels.push(s);
                });

                vm.shipmentEditor.stops.other = [];
                _.forEach(vm.templateEditor.stops.other, function (templateStop) {
                    if (templateStop.type !== 'blank') {
                        const shipmentStop = vm.shipmentEditor.addStop(templateStop.type);
                        applyTemplateStop(templateStop, shipmentStop);
                    }
                });
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function setTemplateStop(templateStop, shipmentStop) {
        if (shipmentStop.type === 'address' && shipmentStop.address.value) {
            templateStop.type = shipmentStop.type;
            templateStop.address.value = shipmentStop.address.value;
        }
        if (shipmentStop.type === 'geofence' && shipmentStop.geofence.value) {
            templateStop.type = shipmentStop.type;
            templateStop.geofence.value = shipmentStop.geofence.value;
        }
    }

    function showTemplates() {
        vm.startPage.isShowingTemplates = true;
        searchTemplates();
    }

    function templateFilter(template) {
        if (ShipmentTemplatesDataLoaderService.isSearchRequired || !vm.templateSearchText) {
            return true;
        }

        const textToMatch = vm.templateSearchText.toLowerCase();

        if (template.name.toLowerCase().indexOf(textToMatch) > -1) {
            return true;
        }

        let foundInStop = false;
        _.forEach(template.formattedStops, function (stop) {
            if (stop.address && stop.address.toLowerCase().indexOf(textToMatch) > -1) {
                foundInStop = true;
                return false;
            }
        });
        return foundInStop;
    }

    function toFormattedStop(templateStop) {
        const stop = {
            type: templateStop.stopType,
            address: null,
            isGeofence: false
        };

        if (templateStop.geofenceId) {
            const geofence = _.find(vm.availableGeofences, { geofenceId: templateStop.geofenceId });
            if (geofence) {
                stop.isGeofence = true;
                stop.address = geofence.name + ' (geofence)';
            }
        } else {
            stop.address = templateStop.address;
        }

        return stop;
    }

    function updateTemplate() {
        vm.templateEditor.device.value = vm.shipmentEditor.device.value;
        vm.templateEditor.sentinels = vm.shipmentEditor.sentinels;
        vm.templateEditor.shipmentEmails.value = vm.shipmentEditor.shipmentEmails.value;
        // only refresh the strategies the template already specifies; an unspecified strategy stays
        // unspecified so each shipment created from the template keeps choosing its own
        vm.templateEditor.setTrackingStrategyFromShipmentEditor(vm.shipmentEditor, {
            includeBegin: vm.templateEditor.beginTrackingStrategyType.value !== null,
            includeEnd: vm.templateEditor.endTrackingOption.value !== null,
            reverseGeofences: vm.startPage.reverseGeofences
        });
        const editorBeginDateMoment = moment(vm.shipmentEditor.beginDate.value, "L");
        const editorEndDateMoment = moment(vm.shipmentEditor.endDate.value, "L");
        if (editorBeginDateMoment.isValid() && editorEndDateMoment.isValid()) {
            const duration = editorEndDateMoment.startOf('day').diff(editorBeginDateMoment.startOf('day'), 'days');
            vm.templateEditor.duration.value = duration >= vm.templateEditor.duration.min && duration <= vm.templateEditor.duration.max ? duration : null;
        }

        vm.templateEditor.stops.other = [];
        _.forEach(vm.shipmentEditor.stops.other, function (stop) {
            vm.templateEditor.stops.other.push(stop);
        });

        const promise = vm.templateEditor.save();
        if (promise === null) {
            reportTrackingStrategyError();
            return;
        }
        $rootScope.loading = true;
        promise.then(
            function (result) {
                vm.feedback.addSuccess(vm.startPage.selectedTemplateName + ' has been saved');
            },
            function (error) {
                vm.feedback.addErrorFromError(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    // the save-as-template card only renders the name and duration errors, so a tracking strategy
    // copied from an incomplete shipment has to be reported through the feedback panel
    function reportTrackingStrategyError() {
        if (vm.templateEditor.hasTrackingStrategyError()) {
            vm.feedback.addError('The shipment\'s tracking strategy is incomplete, so it can not be saved to the template');
        }
    }

    // applies the selected template's tracking strategies to the shipment; strategies the template
    // does not specify leave the shipment's current values alone
    function applyTemplateTrackingStrategy() {
        const strategy = vm.templateEditor.resolveTrackingStrategy(vm.startPage.reverseGeofences);

        if (strategy.beginTrackingStrategyType) {
            vm.shipmentEditor.beginTrackingStrategyType.value = strategy.beginTrackingStrategyType;
            clearEndGeofence();
            clearBeginGeofence();
            if (strategy.beginTrackingStrategyType === 'ArrivalGeofence' && strategy.beginGeofence) {
                selectEndGeofence(strategy.beginGeofence);
            } else if (strategy.beginTrackingStrategyType === 'DepartureGeofence' && strategy.beginGeofence) {
                selectBeginGeofence(strategy.beginGeofence);
            }
        }

        if (strategy.endTrackingOption) {
            vm.shipmentEditor.endTrackingOption.value = strategy.endTrackingOption;
            clearEndGeofence2();
            if (vm.templateEditor.isGeofenceEndOption(strategy.endTrackingOption) && strategy.endGeofence) {
                selectEndGeofence2(strategy.endGeofence);
            }
            vm.shipmentEditor.arrivalLightLevel.value = strategy.arrivalLightLevel;
            vm.shipmentEditor.arrivalLightLevelThrottleHours.value = strategy.arrivalLightLevelThrottleHours;
            vm.shipmentEditor.completionDelay.value = strategy.completionDelay;
            vm.shipmentEditor.arrivalLightLevel.validate();
            vm.shipmentEditor.arrivalLightLevelThrottleHours.validate();
            vm.shipmentEditor.completionDelay.validate();
        }
    }

    function validateStart() {
        vm.shipmentEditor.endDate.validate();
        vm.shipmentEditor.beginDate.validate();
        vm.shipmentEditor.device.validate();
        vm.shipmentEditor.endGeofence.validate();
        vm.shipmentEditor.endGeofence2.validate();
        vm.shipmentEditor.beginGeofence.validate();
        vm.shipmentEditor.shipmentEmails.validate();

        vm.startPage.isDevicePristine = false;

        vm.shipmentEditor.sentinelValidation.errors.tooMany =
            vm.shipmentEditor.device.value === null && vm.shipmentEditor.sentinels.length > 1;

        vm.startPage.isValid = !vm.shipmentEditor.referenceNumber.hasError() &&
            !vm.shipmentEditor.device.hasError() &&
            !vm.shipmentEditor.sentinelValidation.hasError();

        if (vm.shipmentEditor.endTrackingOption.value === 'date/time') {
            vm.startPage.isValid = vm.startPage.isValid && !vm.shipmentEditor.endDate.hasError();
        }

        if (vm.shipmentEditor.beginTrackingStrategyType.value === 'date/time') {
            vm.startPage.isValid = vm.startPage.isValid && !vm.shipmentEditor.beginDate.hasError();
        }

        if (vm.shipmentEditor.beginTrackingStrategyType.value === 'ArrivalGeofence') {
            vm.startPage.isValid = vm.startPage.isValid && !vm.shipmentEditor.endGeofence.hasError();
        }

        if (vm.shipmentEditor.beginTrackingStrategyType.value === 'DepartureGeofence') {
            vm.startPage.isValid = vm.startPage.isValid && !vm.shipmentEditor.beginGeofence.hasError();
        }

        if (vm.shipmentEditor.endTrackingOption.value === 'ArrivalGeofence') {
            vm.startPage.isValid = vm.startPage.isValid && !vm.shipmentEditor.endGeofence2.hasError();
        }

        if (vm.shipmentEditor.endTrackingOption.value === 'ArrivalMultipleOr' || vm.shipmentEditor.endTrackingOption.value === 'ArrivalMultipleAnd') {
            if (vm.shipmentEditor.endGeofence2.value !== null) {
                vm.startPage.isValid = vm.startPage.isValid && !vm.shipmentEditor.endGeofence2.hasError();
            }
            if (vm.shipmentEditor.arrivalLightLevel.value !== null) {
                vm.startPage.isValid = vm.startPage.isValid && !vm.shipmentEditor.arrivalLightLevel.hasError();
            }
            if (vm.shipmentEditor.completionDelay.value !== null) {
                vm.startPage.isValid = vm.startPage.isValid && !vm.shipmentEditor.completionDelay.hasError();
            }
            if (vm.shipmentEditor.endTrackingOption.value === 'ArrivalMultipleOr' && vm.shipmentEditor.endGeofence2.value === null && vm.shipmentEditor.arrivalLightLevel.value === null) {
                vm.shipmentEditor.endGeofence2.errors.thisOrLight = true;
                vm.shipmentEditor.arrivalLightLevel.errors.thisOrGeofence = true;
            } else if (vm.shipmentEditor.endTrackingOption.value === 'ArrivalMultipleAnd') {
                vm.shipmentEditor.endGeofence2.errors.thisOrLight = false;
                vm.shipmentEditor.endGeofence2.errors.isBlank = vm.shipmentEditor.endGeofence2.value === null;
                vm.shipmentEditor.arrivalLightLevel.errors.thisOrGeofence = false;
                vm.shipmentEditor.arrivalLightLevel.errors.isBlank = vm.shipmentEditor.arrivalLightLevel.value === null;
            } else {
                vm.shipmentEditor.endGeofence2.errors.thisOrLight = false;
                vm.shipmentEditor.endGeofence2.errors.isBlank = false;
                vm.shipmentEditor.arrivalLightLevel.errors.thisOrGeofence = false;
                vm.shipmentEditor.arrivalLightLevel.errors.isBlank = false;
            }
        }
    }

    function validateStops() {
        _.forEach(vm.shipmentEditor.stops.other, function (stop) {
            stop.validate();
        });
        vm.shipmentEditor.validateStops();
        vm.stopsPage.isValid = vm.shipmentEditor.stops.hasError();
    }

    function validateSubscribers() {
        vm.shipmentEditor.shipmentEmails.validate();
        vm.startPage.isSubscribersValid = vm.shipmentEditor.shipmentEmails.hasError();
    }
}
